module.exports = __webpack_public_path__ + "static/logo-06ed26df366a6b4ae5726908c2714961.png";